import {
    File,
    FileImage,
    FileVideo,
    FileArchive,
    FileText,
    X
} from "lucide-react";

export default function SelectedFileCard({

    file,

    onRemove

}){

    if(!file){

        return null;

    }

    function getIcon(){

        const type =
            file.type || "";

        const name =
            file.name?.toLowerCase() || "";

        if(type.startsWith("image/")){

            return <FileImage size={22}/>;

        }

        if(type.startsWith("video/")){

            return <FileVideo size={22}/>;

        }

        if(

            name.endsWith(".zip") ||

            name.endsWith(".rar") ||

            name.endsWith(".7z")

        ){

            return <FileArchive size={22}/>;

        }

        if(

            type.includes("pdf") ||

            type.includes("word") ||

            type.includes("text")

        ){

            return <FileText size={22}/>;

        }

        return <File size={22}/>;

    }

    function formatSize(bytes){

        if(!bytes){

            return "0 B";

        }

        const sizes=[

            "B",

            "KB",

            "MB",

            "GB",

            "TB"

        ];

        const i=Math.floor(

            Math.log(bytes)/Math.log(1024)

        );

        return (

            bytes/

            Math.pow(1024,i)

        ).toFixed(2)

        +" "+sizes[i];

    }

    return(

        <div className="selected-file-card">

            <div className="selected-file-left">

                <div className="selected-file-icon">

                    {getIcon()}

                </div>

                <div className="selected-file-info">

                    <div className="selected-file-name">

                        {file.name}

                    </div>

                    <div className="selected-file-size">

                        {formatSize(file.size)}

                    </div>

                </div>

            </div>

            <button

                type="button"

                className="selected-file-remove"

                onClick={onRemove}

            >

                <X size={16}/>

            </button>
<style>{`.selected-file-card{

    margin-top:22px;

    padding:18px;

    border:1px solid #E5E7EB;

    border-radius:16px;

    background:#FFF;

    display:flex;

    justify-content:space-between;

    align-items:center;

    gap:18px;

    transition:.2s;

}

.selected-file-card:hover{

    border-color:#CBD5E1;

}

.selected-file-left{

    display:flex;

    align-items:center;

    gap:16px;

    min-width:0;

}

.selected-file-icon{

    width:52px;

    height:52px;

    border-radius:14px;

    display:flex;

    justify-content:center;

    align-items:center;

    background:#EEF4FF;

    color:#2563EB;

    flex-shrink:0;

}

.selected-file-info{

    min-width:0;

}

.selected-file-name{

    font-size:15px;

    font-weight:600;

    color:#0F172A;

    overflow:hidden;

    text-overflow:ellipsis;

    white-space:nowrap;

}

.selected-file-size{

    margin-top:5px;

    font-size:13px;

    color:#64748B;

}

.selected-file-remove{

    width:36px;

    height:36px;

    border:none;

    border-radius:10px;

    background:#FEE2E2;

    color:#DC2626;

    display:flex;

    align-items:center;

    justify-content:center;

    cursor:pointer;

    transition:.18s;

}

.selected-file-remove:hover{

    background:#FECACA;

}`}</style>
        </div>

    );

}